<template>
  <div class="addresses">
    <Address v-for="address in combinedAddresses.slice(0,3)" :value="address" :key="JSON.stringify(address)" />
    <div class="more" v-if="combinedAddresses.length > 3">...{{combinedAddresses.length - 3}} more...</div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: mapGetters(["combinedAddresses"]),
  methods: mapActions(["loadTeamAddresses", "loadUserAddresses"]),
  mounted() {
    this.loadUserAddresses();
    this.loadTeamAddresses();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/settings/ViewAddresses.vue